import { Component, effect, inject, input } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';
import { CompilingSectionService } from '../../../../services/compiling/section.service';
import { CompiledSubSectionComponent } from '../sub-section/sub-section.component';

@Component({
  selector: 'lib-compiled-section',
  templateUrl: './section.component.html',
  imports: [TooltipModule, CompiledSubSectionComponent],
  providers: [CompilingSectionService],
})
export class CompiledSectionComponent {
  protected sectionService = inject(CompilingSectionService);

  uniqueId = input.required<string>();

  constructor() {
    effect(() => {
      this.sectionService.uniqueId = this.uniqueId();
    });
  }
}
